import React from 'react';
import { CnLayoutCol as UICnLayoutCol } from '@/components/cn-layout';
const CnLayoutCol = (props) => {
    const { children } = props || {};
    return <UICnLayoutCol>{children}</UICnLayoutCol>;
};
CnLayoutCol.displayName = 'CnLayoutCol';
export default CnLayoutCol;
export { CnLayoutCol };
